module.exports = __webpack_public_path__ + "img/draw-box.6403f8c4.png";